import React from 'react';
import styled from 'styled-components';
import TrueImpactText from 'shared/design-system/base/TrueImpactText';
import TrueImpactRating from 'shared/design-system/components/TrueImpactRating';
import TrueImpactTextfield from 'shared/design-system/components/TrueImpactTextfield';
import { COLORS } from 'shared/design-system/settings/variables/Colors';
import { SPACERS } from 'shared/design-system/settings/variables/Spacers';

interface FeedbackModalContentProps {
  rating: number;
  isDebug: boolean;
  feedback: string;
  className?: string;
  handleSubmit: () => unknown;
  handleRating: (rating: number) => unknown;
  handleFeedback: (feedback: string) => unknown;
}

const StyledDiv = styled.div`
  max-width: 560px;
  margin-left: auto;
  margin-right: auto;
  padding-top: ${SPACERS.extraLarge};
  .feedback-heading {
    text-align: center;
    margin-bottom: ${SPACERS.large};
  }
  .feedback-box {
    margin-bottom: ${SPACERS.large};
    border-radius: ${SPACERS.extraTiny};
    border: 1px solid ${COLORS.grayLight};
    background-color: ${COLORS.grayLightest};
    padding: ${SPACERS.medium} ${SPACERS.extraLarge};
  }
  .feedback-rating-wrapper {
    .feedback-rating-heading {
      text-align: center;
      margin-bottom: ${SPACERS.small};
    }
  }
  .feedback-text-wrapper {
    .feedback-text-heading {
      margin-bottom: ${SPACERS.small};
    }
  }
`;

const FeedbackModalContent: React.FC<FeedbackModalContentProps> = ({
  rating,
  feedback,
  className,
  handleFeedback,
  handleRating,
}) => {
  return (
    <StyledDiv className={className}>
      <TrueImpactText variant="heading-page" className="feedback-heading">
        Help us improve the way you report!
      </TrueImpactText>
      <div className="feedback-box feedback-rating-wrapper">
        <TrueImpactText
          align="center"
          variant="heading-subheading"
          className="feedback-rating-heading"
        >
          How would you rate your reporting experience with True Impact?
        </TrueImpactText>
        <TrueImpactRating
          count={5}
          value={rating}
          handleChange={handleRating}
        />
      </div>
      {rating ? (
        <div className="feedback-box feedback-text-wrapper">
          <TrueImpactText
            align="center"
            variant="heading-subheading"
            className="feedback-text-heading"
          >
            Why did you give your reporting experience this rating?
          </TrueImpactText>
          <TrueImpactTextfield
            autoFocus={true}
            isTextarea={true}
            value={feedback}
            backgroundColor="whiteBase"
            onChange={handleFeedback}
            placeholder="(Optional) Please describe how this Impact Model template could be better...."
          />
        </div>
      ) : null}
    </StyledDiv>
  );
};

export default FeedbackModalContent;
